import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '浏览漫画',
    links: [
      { label: '热门推荐', path: '/' },
      { label: '排行榜', path: '/rank' },
      { label: '最新更新', path: '/latest' },
      { label: '全部分类', path: '/categories' },
    ],
  },
  {
    title: '漫画分类',
    links: [
      { label: '恋爱漫画', path: '/category/romance' },
      { label: '奇幻冒险', path: '/category/fantasy' },
      { label: '动作热血', path: '/category/action' },
      { label: '悬疑推理', path: '/category/mystery' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about#testimonials' },
      { label: '联系我们', path: '/about#contact' },
      { label: '隐私政策', path: '/privacy' },
    ],
  },
  {
    title: '热门韩漫',
    links: [
      { label: '女神降临', path: '/comic/1' },
      { label: '我独自升级', path: '/comic/2' },
      { label: '再婚皇后', path: '/comic/3' },
      { label: '全知读者视角', path: '/comic/6' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-label font-semibold text-secondary-100 mb-4 whitespace-nowrap">
                {group.title}
              </h3>
              <div className="w-6 h-px bg-secondary-600 mb-4"></div>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-300 hover:text-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="w-full px-4 md:px-6 py-8 md:py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="text-3xl md:text-4xl font-heading font-black text-secondary-100 whitespace-nowrap">
                韩国漫画网
              </span>
              <span className="text-xl md:text-2xl font-heading font-light text-secondary-400 whitespace-nowrap">
                韩漫大全
              </span>
            </div>
            <div className="w-10 h-0.5 bg-secondary-600 mt-3 mb-3"></div>
            <p className="text-xs text-secondary-400">
              收录好看的韩国漫画，打造舒适的在线阅读环境
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
            <p className="text-xs text-secondary-500 order-2 sm:order-1 whitespace-nowrap">
              &copy; {new Date().getFullYear()} 韩国漫画网 版权所有
            </p>
            <div className="flex items-center gap-3 order-1 sm:order-2">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-700 hover:bg-secondary-600 text-secondary-300 hover:text-secondary-100 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-700 hover:bg-secondary-600 text-secondary-300 hover:text-secondary-100 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-700 hover:bg-secondary-600 text-secondary-300 hover:text-secondary-100 transition-colors cursor-pointer" aria-label="哔哩哔哩" rel="nofollow">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}